<template>
  <ParentPage
    class="Reporting"
    :menu="setMenu"
    :root-route-name="rootRouteName"
  />
</template>

<script>
import { mapGetters } from 'vuex'

import { AdminMenu } from '@/config'

import ParentPage from '@/components/ParentPage.vue'

import { fetchProcessesByType } from '@/services/processes'

export default {
  name: 'Config',
  components: {
    ParentPage,
  },
  data() {
    return {
      menu: AdminMenu,
      rootRouteName: 'Config',
    }
  },
  computed: {
    ...mapGetters('user', [
      'canAccessConfig',
    ]),

    setMenu () {
      const menu = JSON.parse(JSON.stringify(this.menu))
      menu.map(link => {
        link.label = link.label[this.$i18n.locale] || link.label
        if (link.items) {
          link.items.map(item => {
            item.label = item.label[this.$i18n.locale] || item.label
            return item
          })
        }

        return link
      })

      return menu
    }
  },
  async created() {
    // Access check
    if (! this.canAccessConfig) {
      this.$router.push({
        name: 'Dashboard',
      })
    }
    if (process.env.VUE_APP_TENANT === 'rvb'){
      this.$store.dispatch('processes/setCurrentProcessType', { processType: 'private' })
      const token = await this.$auth.getTokenSilently()
      await fetchProcessesByType({ token, processType: 'private' }).catch(err => console.log(err))
    }
  },
}
</script>
